import { Box, CircularProgress, Checkbox, FormControl, Grid, Select, Typography, MenuItem, Autocomplete, TextField, Card, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, IconButton ,Paper, TableFooter, Divider} from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { Controller, set, useFormContext } from 'react-hook-form';
import { StepperContext } from '../BookingForm';
import { BookingDetailContext } from '../AddBooking';
import { BookingService } from '../Service';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { Add, Delete, Remove } from '@mui/icons-material';
import { ProviderServices } from '../../Provider/CrudServices';
import { BookingDataContext, DataContext, StepperDataContext } from './UpdateBooking';
import { useParams } from 'react-router-dom';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const ExpertAndServices = () => {
    const {id} = useParams();
    const { 
        activeStep, 
        handleComplete, 
        handleBack, 
        setPreviousServices 
    } = useContext(StepperDataContext);
    
    const { 
        chargeDetails, 
        setChargeDetails, 
        bookingInitiationData, 
        setBookingInitiationData ,
        setExpertDetails
    } = useContext(BookingDataContext);
    
    const { 
        categoryList, 
        setCategoryList, 
        subCategoryList, 
        setSubCategoryList, 
        expertList, 
        setExpertList, 
        serviceList, 
        setServiceList 
    } = useContext(DataContext);
    
    const { 
        control, 
        watch, 
        formState: { isDirty }, 
        setValue 
    } = useFormContext();

    // Watch key form fields
    const latitude = watch('latitude');
    const longitude = watch('longitude');
    const categoryId = watch('categoryId');
    const subCategoryId = watch('subCategoryId');
    const serviceExpert = watch('serviceExpert');
    const services = watch('services') || [];

    // Loading states
    const [loadingCategoryList, setLoadingCategoryList] = useState(false);
    const [loadingSubCategoryList, setLoadingSubCategoryList] = useState(false);
    const [loadingServiceExpertList, setLoadingServiceExpertList] = useState(false);
    const [loadingServiceList, setLoadingServiceList] = useState(false);

    // Bill calculations
    const [billCalculations, setBillCalculations] = useState({
        subTotal: 0,
        total: 0,
        remainingAmounttoWaiveVisitingCharge: 0,
    });

    // Set previous services for reference
    useEffect(() => {
        if (bookingInitiationData.services && bookingInitiationData.services.length > 0) {
            setPreviousServices(bookingInitiationData.services);
        }
    }, []);

    // Fetch category list when coordinates are available
    useEffect(() => {
        if (latitude && longitude) {
            fetchCategoryList();
        }
    }, [latitude, longitude]);

    const fetchCategoryList= async()=>{
        setLoadingCategoryList(true);
        try {
            const categoryListResponse = await BookingService.categoryListByCoordinates({latitude:latitude,longitude:longitude});
            // console.log("category list Response:",categoryListResponse);
            if(categoryListResponse.success===1){
            setCategoryList(categoryListResponse.data)
            }
        } catch (error) {
            
        }finally{
            setLoadingCategoryList(false);
        }
    }
    
    useEffect(() => {
        if (categoryId && latitude && longitude) {
            console.log("entery into fetching sub category list");
            // Only reset if not in edit mode OR if category changed from the original value
            if (!id>0 || categoryId !== bookingInitiationData.categoryId) {
                setValue('subCategoryId', '');
                setValue('serviceExpert', '');
                setValue('services', []);
            }
            console.log("latitude:",latitude);
            console.log("longitude:",longitude);
            const fetchSubCategoryList = async () => {
                setLoadingSubCategoryList(true);
    
                try {
                    const subCategoryListResponse = await BookingService.subCategoryListByCoordinatesAndCategoryId({
                    latitude: latitude,
                    longitude: longitude,
                    categoryId,
                    });
                    // console.log("subCategoryListResponse:",subCategoryListResponse);
                    if (subCategoryListResponse.success == '1') {
                        setSubCategoryList(subCategoryListResponse.data);
                    }
                } catch (error) {
                    // console.error("Failed to fetch sub-category list:", error);
                } finally {
                    setLoadingSubCategoryList(false);
                }
                };
            fetchSubCategoryList();
        }
    }, [categoryId,latitude,longitude]);

    
    // whenever subcategory changes reset all the dependent fields like serviceexpert,services and fech service list and fetch service expert list
    useEffect(() => {
        if (subCategoryId && latitude && longitude) {
            // Only reset if not in edit mode OR if category changed from the original value
            console.log("entery into subcategory");
            console.log("id:",id);
            console.log("bookingInitiationData.subCategoryId:",bookingInitiationData.subCategoryId);
            console.log("subCategoryId:",subCategoryId);
            if (!id>0 || subCategoryId !== bookingInitiationData.subCategoryId) {
                setValue('serviceExpert', '');
                setValue('services', []);
            }
            const fetchServiceList = async () => {
                setLoadingServiceExpertList(true);
        
                try {
                    const providerListResponse = await BookingService.providerListByCoordinatesAndSubCategoryId({
                    latitude: latitude,
                    longitude: longitude,
                    subCategoryId,
                    });
                    console.log("providerListResponse:",providerListResponse);
                    if (providerListResponse.success === 1) {
                    setExpertList(providerListResponse.data);
                    }
                } catch (error) {
                    // console.error("Failed to fetch service list:", error);
                } finally {
                    setLoadingServiceExpertList(false);
                }
            };
            fetchServiceList();
        }
    }, [subCategoryId,latitude,longitude]);

    
    const fetchSelectedExpertData = async()=>{
        try {
            const response = await ProviderServices.fetchProviderDetailsById(serviceExpert);
            const expertDetails = {
                ...response.data?.UserProfile,
                mobileNumber:response.data?.mobileNumber,
            }
            setExpertDetails(expertDetails);
            if(response.success===1){
                setChargeDetails({...chargeDetails,waiveVisitCharge:response.data?.UserProfile?.waiveVisitCharge});
            }
        } catch (error) {
            console.log("error:",error);
        }
    }
    // whenever serviceExpert changes reset all the dependent fields like services and fetch service list
    useEffect(() => {
        console.log(" fetching service list on  basis of service expert and subcategory");
        console.log("serviceExpert:",serviceExpert);
        console.log("subCategoryId:",subCategoryId);
        if (serviceExpert && subCategoryId) {
            fetchSelectedExpertData();
            // Only reset services if not in edit mode OR if expert changed from the original value
            if (!id>0 || serviceExpert !== bookingInitiationData.serviceExpert) {
                setValue('services', []);
            }
            const fetchServiceList = async () => {
                setLoadingServiceList(true);
        
                try {
                const serviceListResponse = await BookingService.serviceList({subCategoryId:subCategoryId,providerId:serviceExpert});
                console.log("serviceListResponse:",serviceListResponse);
                if (serviceListResponse.success === 1) {
                    setServiceList(serviceListResponse.data);
                }
                } catch (error) {
                // console.error("Failed to fetch service list:", error);
                } finally {
                setLoadingServiceList(false);
                }
            };
            fetchServiceList();
        }
    }, [serviceExpert,subCategoryId]);
    
    useEffect(()=>{
        if(services.length>0){
            // Function to find the highest visiting charge
            const highestVisitingCharge = Math.max(...services.map(service => parseFloat(service.charges.vistingCharge)));
            
            // Function to find the maximum additional charge
            const maxAdditionalCharge = Math.max(...services.map(service => parseFloat(service.charges.additionalCharge)));
            
            // Function to check if any service is not refundable
            const isAnyNotRefundable = services.some(service => !service.charges.isRefundable);
            
            // Function to find the minimum refundable amount
            const minRefundableAmount = Math.min(...services.map(service => parseFloat(service.charges.refundableAmount)));
            
            // Function to find the maximum refundable duration
            const maxRefundableDuration = Math.max(...services.map(service => service.charges.refundableDuration));

            // Funtion to  find minimum cancellation time
            const minCancellationTime = Math.min(...services.map(service => service.charges.timeLimitForCancellation));
            
            // Function to find the highest cancellation charge in percent
            const highestCancellationChargeInPercent = Math.max(...services.map(service => parseFloat(service.charges.cancellationChargeInPercent)));
            
            
            const subTotal= services.reduce((acc, service) => acc + (service.price * service.quantity), 0).toFixed(2);
            const visitingCharge = parseFloat(subTotal)>parseFloat(chargeDetails?.waiveVisitCharge)? parseFloat(0).toFixed(2):parseFloat(highestVisitingCharge).toFixed(2);
            const total = parseFloat(subTotal) + parseFloat(visitingCharge);
            const remainingAmounttoWaiveVisitingCharge = parseFloat(chargeDetails?.waiveVisitCharge) - parseFloat(subTotal);
            
            setBillCalculations({
                ...billCalculations,
                subTotal:subTotal,
                total:total,
                // total:parseFloat(subTotal)>parseFloat(chargeDetails?.waiveVisitCharge)? parseFloat(subTotal).toFixed(2):parseFloat(parseFloat(subTotal)+parseFloat(chargeDetails?.vistingCharge)).toFixed(2),
                remainingAmounttoWaiveVisitingCharge:remainingAmounttoWaiveVisitingCharge,
            });
            setChargeDetails({
                ...chargeDetails,
                vistingCharge:highestVisitingCharge,
                additionalCharge:maxAdditionalCharge,
                isRefundable:isAnyNotRefundable,
                refundableAmount:minRefundableAmount,
                refundableDuration:maxRefundableDuration,
                minCancellationTime:minCancellationTime,
                cancellationChargeInPercent:highestCancellationChargeInPercent,
            }); 
        }else{
            setChargeDetails({
                ...chargeDetails,
                vistingCharge:0,
                additionalCharge:0,
                isRefundable:false,
                refundableAmount:0,
                refundableDuration:0,
                minCancellationTime:0,
                cancellationChargeInPercent:0,
            });
            setBillCalculations({
                ...billCalculations,
                subTotal:0,
                total:0,
                remainingAmounttoWaiveVisitingCharge:0,
            });
        }
    },[services]);
    
    
    const handleQuantityChange = (id, quantity) => {
        const items = services.map(service => 
            service.id === id ? { ...service, quantity: parseInt(quantity) || 0,serviceTime:(service.serviceTime/service.quantity)* parseInt(quantity) || 0} : service
        );
        setValue('services',items,{
            shouldDirty: true,
            shouldTouch: true
        });
    };

    const handleDeleteService = (id) => {
        const updatedServices = services.filter(service => service.id !== id);
        // setSelectedServices(updatedServices);
        setValue('services', updatedServices); // Update the form value
    };
  return (
    <>
        <Grid container spacing={2} >
                {/* ............left section................... */}
            <Grid item xs={12} lg={5}>
                <Typography sx={{fontWeight:'600',fontSize:'0.85rem',fontFamily: 'Poppins',color:(!latitude && !longitude)&&'lightGray'}}>Select Category<span style={{color:(!latitude && !longitude)?'lightGray':'#d32f2f'}}>*</span></Typography>
                <Box sx={{display:'flex',gap:2,alignItems:'center'}}>
                    <Controller
                        name='categoryId'
                        control={control}
                        rules={{required:'select category'}}
                        render={({field,fieldState:{error}})=>(
                            <Autocomplete
                                fullWidth
                                {...field}
                                disabled={!latitude && !longitude}
                                options={categoryList}
                                getOptionLabel={(option) => option?.catTitle || ''}
                                isOptionEqualToValue={(option, value) =>
                                    option.catId === (value?.catId || value)
                                }
                                onChange={(event, newValue) => {
                                    field.onChange(newValue ? newValue.catId : null);
                                }}
                                value={categoryList.find(option => option.catId === field.value) || null}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        // label="Select SAC Code*"
                                        placeholder='Search and Select Category'
                                        error={!!error}
                                        // helperText={error ? error.message : ''}
                                        size="small"
                                        inputProps={{
                                            ...params.inputProps,
                                            style: { fontSize: '0.75rem' }
                                        }}
                                    />
                                )}
                                renderOption={(props, option) => (
                                    <MenuItem {...props} style={{ fontSize: '0.75rem', textTransform: 'capitalize' }}>
                                    {option.catTitle || ''}
                                    </MenuItem>
                                )}
                            />
                        )}  
                    />
                    {loadingCategoryList && <CircularProgress/>}
                </Box>
            </Grid>
            <Grid item xs={0} lg={2}/>
            <Grid item xs={12} lg={5}>
                <Typography sx={{fontWeight:'600',fontSize:'0.85rem',fontFamily: 'Poppins',color:!categoryId && 'lightGray'}}>Select Sub-Category<span style={{color:!categoryId?'lightGray':'#d32f2f'}}>*</span></Typography>
                <Box sx={{display:'flex',gap:2,alignItems:'center'}}>
                    <Controller
                        name='subCategoryId'
                        control={control}
                        rules={{required:'select sub-category'}}
                        render={({field,fieldState:{error}})=>(
                            <Autocomplete
                                fullWidth
                                {...field}
                                disabled={!categoryId}
                                options={subCategoryList|| []}
                                getOptionLabel={(option) => option?.subCatTitle || ''}
                                isOptionEqualToValue={(option, value) =>
                                    option.subCatId === (value?.subCatId || value)
                                }
                                onChange={(event, newValue) => {
                                    field.onChange(newValue ? newValue.subCatId : null);
                                }}
                                value={subCategoryList.find(option => option.subCatId === field.value) || null}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        // label="Select SAC Code*"
                                        placeholder='Search and Select Sub-Category'
                                        error={!!error}
                                        // helperText={error ? error.message : ''}
                                        size="small"
                                        inputProps={{
                                            ...params.inputProps,
                                            style: { fontSize: '0.75rem' }
                                        }}
                                    />
                                )}
                                renderOption={(props, option) => (
                                    <MenuItem {...props} style={{ fontSize: '0.75rem', textTransform: 'capitalize' }}>
                                        {option.subCatTitle || ''}
                                    </MenuItem>
                                )}
                            />
                        )}  
                    />
                    {loadingSubCategoryList && <CircularProgress/>}
                </Box>
            </Grid>
            <Grid item xs={12} lg={5}>
                <Typography sx={{fontWeight:'600',fontSize:'0.85rem',fontFamily: 'Poppins',color:!subCategoryId && 'lightGray'}}>Select Service Expert<span style={{color:!subCategoryId ? 'lightGray' : '#d32f2f'}}>*</span></Typography>
                <Box sx={{display:'flex',gap:2,alignItems:'center'}}>
                    <Controller
                        name='serviceExpert'
                        control={control}
                        rules={{required:'Select Service Expert'}}
                        render={({field,fieldState:{error}})=>(
                            <Autocomplete
                                fullWidth
                                {...field}
                                disabled={!subCategoryId}
                                options={expertList|| []}
                                // getOptionLabel={(option) => option?.subCatTitle || ''}
                                getOptionLabel={(option) => {
                                    if (!option) return '';
                                    const expertLabel = option?.firstName ? `${option.firstName} ${option.lastName}` : '';
                                    const mobileNumber = option?.mobileNumber ? `(${option.mobileNumber})` : '';
                                    const distance = option?.distance ? `(${option.distance} km)` : '';
                                    return `${expertLabel} | ${mobileNumber} | ${distance}`;
                                }}
                                isOptionEqualToValue={(option, value) =>
                                    option.userId === (value?.userId || value)
                                }
                                onChange={(event, newValue) => {
                                    field.onChange(newValue ? newValue.userId : null);
                                }}
                                value={expertList.find(option => option.userId === field.value) || null}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        // label="Select SAC Code*"
                                        placeholder='Search and Select Expert'
                                        error={!!error}
                                        // helperText={error ? error.message : ''}
                                        size="small"
                                        inputProps={{
                                            ...params.inputProps,
                                            style: { fontSize: '0.75rem' }
                                        }}
                                    />
                                )}
                                renderOption={(props, option) => (
                                    <MenuItem {...props} style={{ fontSize: '0.75rem', textTransform: 'capitalize' }}>
                                        {option.firstName || '' + option.lastName || ''} | {option.mobileNumber || ''} | {option.distance+' '+'km' || ''}
                                    </MenuItem>
                                )}
                            />
                        )}  
                    />
                    {loadingServiceExpertList && <CircularProgress/>}
                </Box>
            </Grid>
            
        </Grid>
        
        <Divider sx={{my:'2%',borderBlockStyle:'dashed',borderBlockWidth:'1px'}}/>

        <Grid container spacing={2} >
            <Grid item xs={12} lg={5}>
                <Typography sx={{fontWeight:'600',fontSize:'0.85rem',fontFamily: 'Poppins',color:!serviceExpert && 'lightGray'}}>Select Services<span style={{color:!serviceExpert ? 'lightGray': '#d32f2f'}}>*</span></Typography>
                <Box sx={{display:'flex',gap:2,alignItems:'center'}}>
                    <Controller
                        name='services'
                        control={control}
                        rules={{ required: 'Select service' }}
                        render={({ field, fieldState: { error } }) => (
                        <Autocomplete
                            fullWidth
                            {...field}
                            multiple
                            disabled={!serviceExpert}
                            disableCloseOnSelect
                            options={serviceList}
                            getOptionLabel={(option) => option.title}
                            renderOption={(props, option, { selected }) => (
                            <li {...props} key={option.id} style={{fontSize:'0.75rem'}} > 
                                <Checkbox
                                icon={icon}
                                checkedIcon={checkedIcon}
                                style={{ marginRight: 8 }}
                                checked={selected}
                                />
                                {option.title}
                            </li>
                            )}
                            renderInput={(params) => (
                            <TextField
                                {...params}
                                InputProps={{
                                ...params.InputProps,
                                style: { fontSize: '0.75rem',color:'#000' },
                                }}
                                size='small'
                                error={!!error}
                                variant="outlined"
                                placeholder="Select services"
                            />
                            )}
                            onChange={(_, newValue) => {
                            const servicesWithQuantity = newValue.map(service => ({
                                ...service,
                                quantity: service.quantity || 1
                            }));
                            field.onChange(servicesWithQuantity);
                            }}
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                            renderTags={() => null}
                        />
                        )}
                    />
                    {loadingServiceList && <CircularProgress />}
                </Box>
            </Grid>
            <Grid item xs={12} sx={{display:services.length>0?'block':'none'}}>
                <Box>
                    <Typography sx={{fontWeight:'600',color:'#494949'}}>Service Details</Typography>
                    <Card sx={{bgcolor:'#dadada4d'}}>
                        <Grid container>
                            <Grid item xs={12}>
                                <Box sx={{p:'1% 2%',display:'flex',justifyContent:'space-between',borderBottom:'1px solid #BEC2C2'}}>
                                    <Typography sx={{fontWeight:500,color:'#3E3E3E'}}>Your Cart </Typography>
                                    <Typography sx={{fontWeight:500,fontSize:'small',color:'#3E3E3E'}}>{services.length>0? services.length:''} Services</Typography>
                                </Box>
                                <Box>
                                    <TableContainer component={Paper}>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell sx={{fontWeight:600,p:'1% 2%'}} width="40%" >Service</TableCell>
                                                    <TableCell sx={{fontWeight:600,p:'1% 2%'}} align="center" width="12%">Quantity</TableCell>
                                                    <TableCell sx={{fontWeight:600,p:'1% 2%'}} align="center" width="12%">Time</TableCell>
                                                    <TableCell sx={{fontWeight:600,p:'1% 2%'}} align="center" width="12%">Price</TableCell>
                                                    <TableCell sx={{fontWeight:600,p:'1% 2%'}} align="center" width="12%">Total</TableCell>
                                                    <TableCell sx={{fontWeight:600,p:'1% 2%'}} align="right" width="12%" >Action</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {services.map((service) => (
                                                <TableRow key={service.id}>
                                                    <TableCell sx={{ p: 1 }}>{service.title}</TableCell>
                                                    <TableCell align="center" sx={{ p: 1 }}>
                                                        <Paper sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                                            <IconButton
                                                            size="small"
                                                            onClick={() => handleQuantityChange(service.id, Math.max(1, service.quantity - 1))}
                                                            >
                                                            <Remove sx={{color:'#1A44B8'}} fontSize='small'/>
                                                            </IconButton>
                                                            
                                                            <TextField
                                                            type="number"
                                                            value={service.quantity}
                                                            onChange={(e) =>{
                                                                if(e.target.value<1){
                                                                e.target.value=1;
                                                                }
                                                                handleQuantityChange(service.id, e.target.value)
                                                            } }
                                                            inputProps={{ 
                                                                min: 1,
                                                                style: { 
                                                                textAlign: 'center', 
                                                                width: '2em',
                                                                '-moz-appearance': 'textfield',
                                                                '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                                                                    '-webkit-appearance': 'none',
                                                                    margin: 0
                                                                }
                                                                } 
                                                            }}
                                                            size="small"
                                                            variant="standard"
                                                            sx={{ 
                                                                mx: 1,
                                                                "& .MuiInput-underline:before": { borderBottom: "none" },
                                                                "& .MuiInput-underline:after": { borderBottom: "none" },
                                                                "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                                                borderBottom: "none"
                                                                },
                                                                "& .MuiInputBase-input": {
                                                                borderLeft: "1px solid #ccc",
                                                                borderRight: "1px solid #ccc",
                                                                px: 0 
                                                                }
                                                            }}
                                                            />

                                                            <IconButton
                                                            size="small"
                                                            onClick={() => handleQuantityChange(service.id, service.quantity + 1)}
                                                            >
                                                            <Add fontSize='small' sx={{color:'#1A44B8'}}/>
                                                            </IconButton>
                                                        </Paper>
                                                    </TableCell>
                                                    <TableCell align="center" sx={{ p: 1 }}>
                                                        {service.serviceTime} mins
                                                    </TableCell>
                                                    <TableCell sx={{ p: 1 ,textAlign:'center'}}>₹{service.price}</TableCell>                                                                       
                                                    <TableCell sx={{ p: 1 ,textAlign:'center'}} >₹{parseFloat(service.price*service.quantity).toFixed(2)}</TableCell>
                                                    <TableCell align="right" sx={{ p: 1 }}>
                                                        <IconButton
                                                            aria-label="delete"
                                                            onClick={() => handleDeleteService(service.id)}
                                                            size="small"
                                                            color='error'
                                                        >
                                                            <Delete />
                                                        </IconButton>
                                                    </TableCell>
                                                </TableRow>
                                                ))}
                                                <TableRow sx={{P:0}}>
                                                    <TableCell rowSpan={'2'} colSpan={2}/>
                                                    <TableCell  sx={{textAlign:'right', fontWeight:'600',borderBottom:'none',p:1}} colSpan={2}>SubTotal:</TableCell>
                                                    <TableCell sx={{textAlign:'right',borderBottom:'none',p:1}}>₹{billCalculations.subTotal}</TableCell>
                                                </TableRow>
                                                
                                                <TableRow sx={{borderBottom:'1px solid lightGray'}}>
                                                <TableCell  
                                                    sx={{
                                                    textAlign:'right',
                                                    p:1
                                                    }} 
                                                    colSpan={2}
                                                >
                                                    Visiting Charge:
                                                </TableCell>
                                                <TableCell 
                                                    sx={{
                                                    textAlign:'right',
                                                    p:1
                                                    }}
                                                >
                                                    ₹{parseFloat(billCalculations.subTotal)>parseFloat(chargeDetails?.waiveVisitCharge)? parseFloat(0).toFixed(2):parseFloat(chargeDetails?.vistingCharge).toFixed(2)}
                                                </TableCell>
                                                </TableRow>                          
                                                
                                                <TableRow>
                                                    <TableCell colSpan={4} sx={{
                                                        textAlign:'right', 
                                                        fontWeight:'600',
                                                        borderBottom: 'none',p:1
                                                    }}>Total:</TableCell>
                                                    <TableCell sx={{
                                                        textAlign:'right',
                                                        fontWeight:'600',
                                                        borderBottom: 'none',p:1
                                                    }}>
                                                        ₹{parseFloat(billCalculations.total).toFixed(2)}
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                        <Box sx={{p:'1%'}}>
                                            <Typography sx={{width:'100%',fontSize:'0.75rem',color:'#3e3e3e'}}>
                                                {billCalculations.remainingAmounttoWaiveVisitingCharge>0 && `Add more items worth ₹${billCalculations.remainingAmounttoWaiveVisitingCharge} to waive visiting charge`}
                                            </Typography>
                                        </Box>
                                    </TableContainer>
                                </Box>
                            </Grid>
                        </Grid>
                    </Card>
                </Box>
            </Grid>
        </Grid>
    </>
  );
}

export default ExpertAndServices;
